export const allFieldsLead = (tagsOpt, onCountrySelect) => {
  return [
    {
      label: "Names",
      name: "name",
      placeholder: "Enter your name",
      rules: [{ required: true, message: "Please input your name!" }],
      type: "text",
    },
    {
      label: "Email",
      name: "email",
      placeholder: "Enter your email",
      rules: [{ required: true, message: "Please input your email!" }],
      type: "text",
    },
    {
      label: "Phone",
      name: "phone",
      placeholder: "Enter your phone number",
      rules: [{ required: true, message: "Please input your number!" }],
      type: "number",
      onCountrySelect, // Pass onCountrySelect handler here
    },
    {
      label: "Tags",
      name: "tags",
      placeholder: "Select or type tags",
      type: "select",
      multiple: "multiple",
      options: tagsOpt ?? [],
    },
  ];
};
